const server = {
    //apiUrl: 'http://localhost:8080/api'
    apiUrl: 'https://xeelabs.onrender.com/api'
};

export default server;